import { values, keys, without, flatten } from 'lodash';
import getRow from './getRow';
import getTitle from './getTitle';

const emptyTable = { total: {} };
const seasonsPeriods = [5, 1];

const getDetailsData = (apiData, profileType) => {
    if (!apiData) { return []; }

    const data = keys(apiData).map(key =>
        seasonsPeriods.map((period) => {
            const recordsData = apiData[key][period].data;
            const rows = values(recordsData.recordByRaceType);
            const total = rows.find(row => row.groupName === 'total');

            if (!total) { return emptyTable; }

            const isIre = key.includes('IRE');

            return {
                rows: without(rows, total)
                    .map(row => getRow(row, profileType, isIre)),
                total: getRow(total, profileType, isIre),
                title: total.racesNumber && getTitle(recordsData.seasonInfo),
            };
        })
    );

    const sortedData = [...data].sort((item1, item2) =>
        item2[0].total.runs - item1[0].total.runs
    );

    return flatten(sortedData).filter(item => item.total.runs);
};

export default getDetailsData;




// WEBPACK FOOTER //
// ./src/js/human/details/helpers/getDetailsData.js